import {
  bool, string, number, func, shape, oneOfType,
} from 'prop-types';
import {
  Card, Input, Small, Icon,
} from 'components/common';
import Tooltip from 'components/common/Tooltip';
import { isNumberInRange } from 'helpers/ValidationUtil';
import { patterns } from 'helpers/behaviors';

import './NumberInputPanel.scss';

const MIN_VALUE = 0;
const MAX_VALUE = 999999999;

const NumberInputPanel = ({
  notBordered,
  name: { display },
  suffix,
  prefix,
  description,
  tooltip,
  behaviors,
  minValue,
  maxValue,
  queryParam,
  ...props
}) => (
  <Card.Content notBordered={notBordered}>
    <div className="filter-number-input-panel" data-selector-type="number-input-panel">
      <Input
        {...props}
        behaviors={behaviors || patterns.readableNaturalRange({
          minValue,
          maxValue,
          noDigits: `${maxValue}`.length,
          autoCorrect: true,
        })}
        dataSelectorId={queryParam}
        type="tel"
        validate={v => (isNumberInRange(v, minValue, maxValue)
          ? ''
          // This message will not be displayed
          // It is only used to trigger error response
          : 'error')}
        errorComponent={null}
        showSuccessIcon={false}
        showFeedbackOnce="dirty"
        title={display}
        rightText={suffix}
        leftText={prefix}
      />
      {tooltip.display && (
        <Tooltip id="numberInput-panel-info" text={tooltip.display} position="top">
          <Icon name="info" secondary small />
        </Tooltip>
      )}
    </div>
    {description && <Small secondary>{description}</Small>}
  </Card.Content>
);

NumberInputPanel.displayName = 'NumberInputPanel';

NumberInputPanel.defaultProps = {
  notBordered: false,
  name: {
    display: '',
  },
  suffix: null,
  prefix: null,
  description: null,
  minValue: MIN_VALUE,
  maxValue: MAX_VALUE,
  tooltip: {
    display: '',
    key: '',
  },
  queryParam: '',
};

NumberInputPanel.propTypes = {
  notBordered: bool,
  name: shape({
    display: '',
  }),
  behaviors: shape({
    coerce: func,
    parse: func,
    normalize: func,
    finalize: func,
    format: func,
  }),
  value: oneOfType([number, string]).isRequired,
  onChange: func.isRequired,
  onBlur: func.isRequired,
  suffix: string,
  prefix: string,
  description: string,
  minValue: number,
  maxValue: number,
  validate: func,
  tooltip: shape({
    display: string,
    key: string,
  }),
  queryParam: string,
};

export default NumberInputPanel;
